import React from 'react';
import { withStyles, createStyles, } from '@material-ui/styles';
import { Typography, DialogTitle, IconButton, } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
var styles = function (theme) { return createStyles({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}); };
var ClosableDialogTitle = withStyles(styles)(function (props) {
    var children = props.children, classes = props.classes, onClose = props.onClose;
    return (React.createElement(DialogTitle, { disableTypography: true, className: classes.root },
        React.createElement(Typography, { variant: "h6" }, children),
        onClose ? (React.createElement(IconButton, { "aria-label": "Close", className: classes.closeButton, onClick: onClose },
            React.createElement(CloseIcon, null))) : null));
});
export default ClosableDialogTitle;
//# sourceMappingURL=ClosableDialogTitle.js.map